;(function() {
/* @ngInject */
function AlreadyAddedSubjectController() {
  let vm = this;

  vm.confirm = confirm;

  function confirm(include, $event) {
    if (vm.onConfirm) {
      vm.onConfirm({ include: include, $event: $event });
    }
  }
}

angular.module("firmaren")
  .component("alreadyAddedSubject", {
    templateUrl: "/app/shared/already-added-subject/already-added-subject.html",
    controller: AlreadyAddedSubjectController,
    controllerAs: "vm",
    bindings: {
      onConfirm: "&"
    }
  });
}());
